enum DeepLinkParams {
  Channel = "channel",
  EntryId = "entry-id",
  GroupId = "group-id",
  TaskId = "task-id",
}

export { DeepLinkParams };
